export default [
  '长期意向',
  '姓名',
  '英文名',
  '职能模块',
  '细分职能',
  '擅长方向',
  '曾任职公司',
  '公司',
  '部门',
  '组别',
  '目前职位',
  '手机',
  '其他',
  '座机',
  '邮箱',
  '地域',
  '性别',
  '规模',
  '管理基金数量',
  '管理基金',
  '任职期',
  '行业',
  '平台',
  '职级',
  '业绩',
  '建议业绩',
  '投资风格',
  '个性标签',
  '学历标签',
  '语言标签',
  '旧系统沟通备注',
  '管理职级',
  '专业职级',
  '下属个数',
  '汇报上级',
  '奖金',
  '期望行业',
  '期望地域',
  '期望固薪',
  '期望奖金',
  '简介',
  '婚育',
  '出生年月',
  '籍贯',
  '学历',
  '本科院校',
  '硕士院校',
  '到现公司时间',
  '从业起始年',
  '微信',
]
